/* Flat TR→EN phrase map for hardcoded strings. The Turkish literal IS the key (default-language-as-key, a standard
   i18n pattern on top of the existing provider). tx("Türkçe") returns EN when language is English, else the TR source.
   Only UI chrome/labels/messages are listed here — never user data, mail/news text, file names, brand names, or
   proposal document content. */
export const EN_PHRASES = {
  // generic actions / status
  "Harita açık değil; önce bir konum açın.": "No map is open — open a location first.",
  "seçiliyor…": "selecting…",
  "Sohbet kaynağı": "Chat source",
  "Kendi anahtarınızla OpenAI veya Claude seçin": "Pick OpenAI or Claude with your own key",
  "Adresi kopyala": "Copy address",
  "Google \"400 redirect_uri_mismatch\" alıyorsanız, Google Cloud Console → ilgili OAuth istemcisi → \"Authorized redirect URIs\" listesine aşağıdaki adresi bir kez ekleyin (ana Gmail bağlantısı etkilenmez):": "If Google shows \"400 redirect_uri_mismatch\", add the address below once to Google Cloud Console → the OAuth client → \"Authorized redirect URIs\" (your main Gmail connection is unaffected):",
  "Kaydedilemedi": "Could not save",
  "Bağlı değil": "Not connected",
  "Bağlantı doğrulandı": "Connection verified",
  "Test ediliyor…": "Testing…",
  "Bağlantıyı test et": "Test connection",
  "seçili": "selected",
  "Varsayılan model": "Default model",
  "Otomatik (önerilen)": "Automatic (recommended)",
  "Durum alınıyor…": "Fetching status…",
  "Yenile": "Refresh",
  "Yönlendiriliyor…": "Redirecting…",
  "var": "yes",
  "yok": "no",

  // AiConnectionCard
  "Ödeme kaynağı kaydedildi — bağlantı yeniden test ediliyor": "Billing source saved — re-testing connection",
  "Her mesaj Emergent kredinizden düşer. Seçtiğiniz model sessizce değiştirilmez.": "Every message is charged to your Emergent credit. Your chosen model is never changed silently.",
  "Her mesaj kendi OpenAI hesabınızdan faturalanır. Seçtiğiniz model sessizce değiştirilmez.": "Every message is billed to your own OpenAI account. Your chosen model is never changed silently.",
  "Otomatik: kısa sohbet ekonomik modele, teklif/e-posta/analiz güçlü modele gider.": "Automatic: short chat uses the economical model; proposals/email/analysis use the stronger model.",
  "OpenAI Billing sayfasını aç": "Open the OpenAI Billing page",
  "Anahtarlar yalnızca sunucu secrets alanında tutulur; değerleri hiçbir ekranda, logda veya sohbette görünmez. Bu ekran yalnızca var/yok durumunu bilir.": "Keys are stored only in the server secrets; their values never appear on any screen, log or chat. This screen only knows present/absent.",
  "Görsel analizi bu modda gönderilmez; fotoğraf incelemesi kendi OpenAI anahtarı modunu gerektirir.": "Image analysis is not sent in this mode; photo review requires your own OpenAI key mode.",

  // GmailConnectionCard
  "Gmail yetkilendirmesi güncellendi.": "Gmail authorisation updated.",
  "Google izin ekranında onay verilmedi.": "Consent was not granted on the Google screen.",
  "Yanlış hesap: yalnızca emre@modihome.co.uk kabul edilir. Bağlantı kurulmadı.": "Wrong account: only emre@modihome.co.uk is accepted. Not connected.",
  "Yalnızca okuma izni kabul edilir; verilen izin fazla olduğu için bağlanmadı.": "Only read access is accepted; the granted scope was too wide, so it did not connect.",
  "Okuma izni (gmail.readonly) verilmedi; bağlanmadı.": "Read access (gmail.readonly) was not granted; not connected.",
  "Güvenlik doğrulaması geçersiz (state); işlem iptal edildi.": "Security check invalid (state); the operation was cancelled.",
  "Yetkilendirme süresi doldu; tekrar deneyin.": "Authorisation expired; please try again.",
  "Google kod değişimi başarısız; tekrar deneyin.": "Google code exchange failed; please try again.",
  "Hesap kimliği doğrulanamadı; bağlanmadı.": "Account identity could not be verified; not connected.",
  "Sunucuda Gmail yapılandırması eksik.": "Gmail configuration is missing on the server.",
  "Geri dönüş isteği eksik/bozuk; işlem iptal edildi.": "Callback request missing/broken; the operation was cancelled.",
  "Bağlantı başlatılamadı": "Could not start connection",
  "Gmail bağlantısı kesilsin mi? Google'daki okuma izni de iptal edilir ve yeniden bağlanmak için izin ekranından geçmeniz gerekir.": "Disconnect Gmail? The Google read access will also be revoked and you will need to go through the consent screen again to reconnect.",
  "Bağlantı kaldırıldı ve Google'da iptal edildi": "Disconnected and revoked at Google",
  "Bağlantı kaldırıldı": "Disconnected",
  "Bağlantı kaldırılamadı": "Could not disconnect",
  "Bağlı · gönderme açık": "Connected · sending on",
  "Bağlı · yalnız okuma": "Connected · read only",
  "Sunucu yapılandırması eksik": "Server configuration missing",
  "Göndermeyi etkinleştir": "Enable sending",
  "Arşiv/Çöp'ü etkinleştir": "Enable Archive/Trash",
  "Bağlantıyı kes": "Disconnect",
  "Google ile bağla": "Connect with Google",
  "Gönderme açık": "Sending on",
  "Gönderme kapalı": "Sending off",
  "Arşiv/Çöp açık": "Archive/Trash on",
  "Arşiv/Çöp kapalı": "Archive/Trash off",
  "İzinler ve bağlantı ayrıntıları": "Permissions and connection details",
  "İzin verilen posta kutusu": "Allowed mailbox",

  // CalendarConnectionCard
  "Yetkilendirme başlatılamadı": "Could not start authorisation",
  "Takvim seçildi": "Calendar selected",
  "Takvim seçilemedi": "Could not select calendar",
  "Bağlı": "Connected",
  "Yetki verilmedi": "Not authorised",
  "Google bağlı değil": "Google not connected",
  "Takvimi etkinleştir": "Enable calendar",
  "Kullanılacak takvim": "Calendar to use",
  "İzinler ve ayrıntılar": "Permissions and details",
  "Etkinlik oluşturma/düzenleme yalnızca ekranda inceleyip onayladığınızda yapılır; asistan tek başına yazamaz.": "Events are created/edited only when you review and approve on screen; the assistant cannot write on its own.",

  // LiveVoiceCard
  "Hazır · oturum kapalı": "Ready · session off",
  "bağlanıyor…": "connecting…",
  "oturum açık": "session open",
  "kapatılıyor…": "closing…",
  "hata": "error",
  "Live konuşma açık — oturum yalnızca JARVIS'e dokununca başlar.": "Live conversation on — a session starts only when you tap JARVIS.",
  "Live konuşma kapalı — ses Emergent kredisiyle çalışır.": "Live conversation off — voice runs on Emergent credit.",
  "Ayar kaydedilemedi": "Could not save setting",
  "Özellik açık": "Feature on",
  "Özellik kapalı": "Feature off",
  "Live konuşma modu": "Live conversation mode",
  "Kendi OpenAI API'nizle gerçek zamanlı konuşma": "Real-time conversation with your own OpenAI API",
  "Emergent kredisiyle sesli konuşma": "Voice conversation on Emergent credit",
  "Ücretli oturum yalnızca JARVIS'e dokunduğunuzda başlar.": "A paid session starts only when you tap JARVIS.",
  "Anahtar sunucuda var olduğunda gerçek erişim ve bakiye ilk oturumda doğrulanır; bu anahtarı açmak oturum başlatmaz.": "When the key exists on the server, real access and balance are verified on the first session; enabling it does not start a session.",
  "Akış: tarayıcı uyandırma kelimesi → whisper-1 → Luna → tts-1 (Emergent kredisi).": "Flow: browser wake word → whisper-1 → Luna → tts-1 (Emergent credit).",

  // Gmail extra
  "Mail okuma bağlı": "Mail reading connected",
  "Google ile uygulama girişi posta kutusu erişimi değildir. Yalnızca okuma izni istenir ve sadece bu hesap kabul edilir:": "Signing into the app with Google is not mailbox access. Only read permission is requested and only this account is accepted:",
  "Gönderme (gmail.send) ve arşiv/çöp (gmail.modify) ayrı izinlerdir; yalnızca siz etkinleştirirseniz istenir. Kalıcı silme izni hiç istenmez — çöp işlemi geri alınabilir.": "Sending (gmail.send) and archive/trash (gmail.modify) are separate permissions, requested only if you enable them. Permanent deletion is never requested — trashing is reversible.",
  "Anahtar/secret değerleri hiçbir ekranda gösterilmez; yalnızca sunucuda var/yok bilgisi okunur.": "Key/secret values are never shown on any screen; only present/absent is read from the server.",

  // Calendar extra
  "Okuma ve onaylı düzenleme açık": "Read and approved editing on",
  "Takvim okuma ve onaylı etkinlik düzenleme için ayrı Google izni gerekir. Takvim silme, paylaşım ve ACL izinleri istenmez.": "Calendar reading and approved event editing need a separate Google permission. Calendar deletion, sharing and ACL permissions are not requested.",
  "birincil": "primary",

  // ---- Phase 2: shared / generic ----
  "Vazgeç": "Cancel",
  "Kapat": "Close",
  "Düzenle": "Edit",
  "Sil": "Delete",
  "Kaydet": "Save",
  "Kaydedildi": "Saved",
  "Yükleniyor…": "Loading…",
  "Güncellenemedi": "Could not update",
  "Kaldırılamadı": "Could not remove",
  "Silinemedi": "Could not delete",
  "İşlem başarısız": "Operation failed",
  "Gelişmiş ayrıntılar": "Advanced details",
  "Gövde": "Body",
  "(boş)": "(empty)",
  "İşleniyor…": "Processing…",
  "Durum": "Status",
  "Başlık": "Title",
  "Müşteri": "Client",
  "Proje": "Project",
  "Bitiş": "End",
  "Yer": "Location",
  "Konu": "Subject",
  "Alıcı": "Recipient",
  "açık": "on",
  "kapalı": "off",
  "evet": "yes",
  "hayır": "no",
  "Dürüst sınır": "Honest limit",
  "Varsayılan model güncellendi": "Default model updated",

  // ---- RecordsPanels ----
  "Başlık gerekli": "Title required",
  "Görev yönetimi": "Task management",
  "Öncelik": "Priority",
  "Teslim": "Due",
  "Not": "Note",
  "İsim gerekli": "Name required",
  "Müşteri rehberi": "Client directory",
  "İsim": "Name",
  "E-posta": "Email",
  "Telefon": "Phone",
  "Adres": "Address",
  "Proje adı gerekli": "Project name required",
  "Aktif şantiyeler": "Active sites",
  "Proje adı": "Project name",
  "İlerleme %": "Progress %",
  "Kapsam": "Scope",

  // ---- ProposalsPanel ----
  "Görsel eklenemedi": "Could not add image",
  "Toplam güncel değil — hesaplama bitene kadar kaydedilemez": "Total is not up to date — cannot save until calculation finishes",
  "Teklif kaydedildi": "Proposal saved",
  "Toplam güncel değil — önce hesaplamanın bitmesini bekleyin": "Total is not up to date — wait for the calculation to finish first",
  "PDF önizleme başarısız": "PDF preview failed",
  "Teklif düzenle": "Edit proposal",
  "Yeni teklif": "New proposal",
  "Ondalık para hesapları backend'de yapılır": "Decimal money calculations are done on the backend",
  "PDF Önizle": "Preview PDF",
  "Belge tipi": "Document type",
  "Teklif": "Proposal",
  "Fatura": "Invoice",
  "Rapor": "Report",
  "İş kalemleri": "Line items",
  "Açıklama": "Description",
  "Kalem ekle": "Add line item",
  "İndirim (£)": "Discount (£)",
  "KDV Yok / No VAT": "No VAT",
  "VAT %20": "VAT 20%",
  "Özel %": "Custom %",
  "ModiHome varsayılan politikası:": "ModiHome default policy:",
  ". VAT yalnızca açık seçimle eklenir.": ". VAT is only added by explicit choice.",
  "Teklif detayları (markalı PDF)": "Proposal details (branded PDF)",
  "Alt başlık": "Subtitle",
  "Geçerlilik (gün)": "Validity (days)",
  "Kısa kapsam özeti": "Short scope summary",
  "Varsayımlar (her satır bir madde)": "Assumptions (one item per line)",
  "Hariç tutulanlar (her satır bir madde)": "Exclusions (one item per line)",
  "Programme / süre": "Programme / duration",
  "Ödeme şartları": "Payment terms",
  "Ölçü, süre, ödeme ve teknik iddialar AI tarafından uydurulmaz; yalnızca girdiğiniz bilgiler PDF'e yazılır. Ek işler yazılı onayla ayrı fiyatlanır.": "Measurements, duration, payment and technical claims are never invented by AI; only the information you enter is written to the PDF. Extra work is priced separately with written approval.",
  "Görseller (teklif PDF'ine eklenir)": "Images (added to the proposal PDF)",
  "Önerilen": "Proposed",
  "Mevcut": "Existing",
  "Eklenebilir fotoğraf yok. Şantiye ekranından (kamera) veya Dosyalar'dan fotoğraf yükleyin.": "No photos available to add. Upload photos from the Site screen (camera) or from Files.",
  "fotoğraf": "photo",
  "eklendi": "added",
  "Önizleme toplamları": "Preview totals",
  "⚠️ Bağlantı hatası — toplam hesaplanamadı. Eski toplam geçersiz sayıldı.": "⚠️ Connection error — total could not be calculated. The previous total is treated as invalid.",
  "Tekrar hesapla": "Recalculate",
  "Hesaplanıyor…": "Calculating…",
  "Ara Toplam": "Subtotal",
  "İndirim": "Discount",
  "KDV Yok (No VAT)": "No VAT",
  "TOPLAM": "TOTAL",
  "Taslak": "Draft",
  "Gönderildi": "Sent",
  "Kısmen onay": "Partial approval",
  "Tam onay": "Full approval",
  "İşe başla": "Start work",
  "Teklif · Fatura · Rapor": "Proposal · Invoice · Report",

  // ---- CalendarPanelReal ----
  "Takvim okunamadı": "Could not read calendar",
  "Taslak güncellendi — önceki onay geçersiz": "Draft updated — previous approval invalidated",
  "Etkinlik taslağı kaydedildi": "Event draft saved",
  "Taslak kaydedilemedi": "Could not save draft",
  "Onay alınamadı": "Could not get confirmation",
  "Bu işlem daha önce uygulanmış — ikinci etkinlik oluşturulmadı": "This action was already applied — a second event was not created",
  "Takvime işlendi (etkinlik: {id})": "Written to calendar (event: {id})",
  "Takvim güncellenemedi": "Could not update calendar",
  "Takvim": "Calendar",
  "Google Takvim — okuma ve onaylı düzenleme (Europe/London)": "Google Calendar — read and approved editing (Europe/London)",
  "Yaklaşan etkinlikler (14 gün)": "Upcoming events (14 days)",
  "Yeni etkinlik": "New event",
  "Bu aralıkta randevu yok.": "No appointments in this range.",
  "Olası mükerrer etkinlikler — inceleyin": "Possible duplicate events — review",
  "Aynı başlık ve saate sahip birden çok kayıt bulundu. Otomatik silinmez; Google Takvim'den elle kaldırabilirsiniz.": "Multiple records with the same title and time were found. They are not deleted automatically; you can remove them manually from Google Calendar.",
  "{n} kez": "{n} times",
  "tüm gün": "all day",
  "Etkinlik düzenleme taslağı": "Event edit draft",
  "Yeni etkinlik taslağı": "New event draft",
  "Tarih (YYYY-AA-GG)": "Date (YYYY-MM-DD)",
  "Başlangıç (SS:DD)": "Start (HH:MM)",
  "Bitiş (SS:DD, boşsa 1 saat)": "End (HH:MM, 1 hour if empty)",
  "Katılımcılar (virgülle)": "Attendees (comma-separated)",
  "Tüm gün": "All day",
  "Katılımcılara Google daveti gönder": "Send Google invite to attendees",
  "Taslağı kaydet": "Save draft",
  "Taslaklar": "Drafts",
  "(başlıksız)": "(untitled)",
  "saat yok": "no time",
  "sürüm {v}": "revision {v}",
  "saat gerekli": "time required",
  "takvime eklendi": "added to calendar",
  "işlendi: {id}": "applied: {id}",
  "Eklendi": "Added",
  "İncele ve onayla": "Review and approve",
  "Takvime yazmak için yukarıdan Takvimi etkinleştirin.": "To write to the calendar, enable Calendar above.",
  "onay": "approval",
  "Başlangıç": "Start",
  "Saat dilimi": "Time zone",
  "Katılımcılar": "Attendees",
  "Davet": "Invite",
  "Google daveti GÖNDERİLECEK": "Google invite WILL BE SENT",
  "gönderilmeyecek": "will not be sent",
  "Takvime ekle": "Add to calendar",
  "Etkinliği güncelle": "Update event",

  // ---- FilesPanel ----
  "{name} yüklendi": "{name} uploaded",
  "Projeye bağla": "Link to project",
  "Açıklama / iş notu": "Description / work note",
  "Örn: Bugün boruyu değiştirdik": "e.g. We replaced the pipe today",
  "Fotoğraf / belge yükle": "Upload photo / document",
  "⚠️ İnternet kesilirse yüklemeler gönderilemez; bağlantı gelince tekrar deneyin. Gürültülü ortamda net olmayan ölçü/adres/tutarı uydurmam — size sorarım.": "⚠️ If the internet drops, uploads cannot be sent; try again when the connection returns. In a noisy environment I will not invent unclear measurements/addresses/amounts — I will ask you.",
  "Tek ekrandan hızlı fotoğraf + not": "Quick photo + note from a single screen",
  "Fotoğraf & belge arşivi": "Photo & document archive",

  // ---- EmailsPanel ----
  "Gelen kutusu okunamadı": "Could not read inbox",
  "Taslak kaydedildi": "Draft saved",
  "Bu gönderim daha önce yapılmış — ikinci e-posta gönderilmedi": "This send was already done — a second email was not sent",
  "Gönderildi · Google mesaj kimliği: {id}": "Sent · Google message id: {id}",
  "Gönderilemedi": "Could not send",
  "E-posta açılamadı": "Could not open email",
  "arşivlendi": "archived",
  "çöpe taşındı": "moved to trash",
  "okundu işaretlendi": "marked read",
  "okunmadı işaretlendi": "marked unread",
  "yıldızlandı": "starred",
  "yıldızı kaldırıldı": "unstarred",
  "önemli işaretlendi": "marked important",
  "önemsiz işaretlendi": "marked unimportant",
  "etiket eklendi": "label added",
  "etiket kaldırıldı": "label removed",
  "E-posta": "Email",
  "(geri alınabilir)": "(reversible)",
  "İçerik açıklaması gerekli": "Content description required",
  "Taslak üretilemedi": "Could not generate draft",
  "AI bağlı değil — şablon taslak üretildi": "AI not connected — template draft generated",
  "Kopyalandı": "Copied",
  "Gerçek Gmail okuma + TR/EN taslak üretimi. Gönderme ve arşiv/çöp yalnızca siz etkinleştirirseniz çalışır.": "Real Gmail reading + TR/EN draft generation. Sending and archive/trash work only if you enable them.",
  "okuma ve arşiv/çöp": "reading + archive/trash",
  "Bağlı · arşiv/çöp açık": "Connected · archive/trash on",
  "AI taslak geçmişi": "AI draft history",
  "Henüz AI taslak geçmişi yok.": "No AI drafts yet.",
  "kullanılamıyor": "unavailable",
  "Ses seçimi sohbet kaynağından bağımsızdır; değiştirmek oturum açmaz. \"Kullanılamıyor\" o ses sağlayıcısının hazır olmadığını gösterir; uygulamanın çevrimdışı olduğu anlamına gelmez.": "Voice choice is independent of the chat source; changing it opens no session. \"Unavailable\" means that voice provider isn't set up — it does not mean the app is offline.",
  "Yeni taslak": "New draft",
  "Taslaklar · onaylı gönderim": "Drafts · approved sending",
  "Gönderme yetkisi verilmedi. Ayarlar → Bağlantılar → Gmail → \"Göndermeyi etkinleştir\" ile izin verin. Taslak hazırlayabilirsiniz; gönderim yetki verilene kadar yapılmaz.": "Send permission has not been granted. Allow it via Settings → Connections → Gmail → \"Enable sending\". You can prepare drafts; sending is not done until permission is granted.",
  "Gövde (düz metin — imzanız Gmail tarafından eklenir)": "Body (plain text — your signature is added by Gmail)",
  "Taslak yok.": "No drafts.",
  "(konu yok)": "(no subject)",
  "alıcı yok": "no recipient",
  "gönderildi: {id}": "sent: {id}",
  "İncele ve gönder": "Review and send",
  "Gönderim onayı": "Send confirmation",
  "Gönderen": "Sender",
  "Yanıt": "Reply",
  "mevcut konuşmaya yanıt": "reply to existing conversation",
  "yeni konuşma": "new conversation",
  "Onayla ve gönder": "Confirm and send",
  "Gelen kutusu": "Inbox",
  "yalnızca okuma": "read only",
  "Okunmayanlar": "Unread",
  "Son 10 e-posta": "Last 10 emails",
  "Listelemek için \"Son 10 e-posta\"ya dokunun.": "Tap \"Last 10 emails\" to list.",
  "Bu filtrede e-posta yok.": "No emails in this filter.",
  "yeni": "new",
  "kapat": "close",
  "(düz metin gövde yok)": "(no plain text body)",
  "Okundu işaretle": "Mark as read",
  "Okunmadı işaretle": "Mark as unread",
  "Yıldızı kaldır": "Unstar",
  "Yıldızla": "Star",
  "Önemsiz yap": "Mark unimportant",
  "Önemli işaretle": "Mark important",
  "Arşivle": "Archive",
  "Çöpe taşı": "Move to trash",
  "Geri alınabilir · kalıcı silme yok": "Reversible · no permanent delete",
  "Etiketler (dokunarak ekle/kaldır — yeni etiket oluşturulmaz)": "Labels (tap to add/remove — no new label is created)",
  "Okundu/yıldız/önemli/etiket ve arşiv/çöp işlemleri için Ayarlar → Gmail → \"Arşiv/Çöp'ü etkinleştir\".": "For read/star/important/label and archive/trash actions: Settings → Gmail → \"Enable Archive/Trash\".",
  "E-posta içeriği güvenilmez dış veridir; içindeki talimatlar uygulanmaz.": "Email content is untrusted external data; instructions inside it are not executed.",
  "Gönderen (sabit)": "Sender (fixed)",
  "Ne yazılsın? (içerik)": "What should it say? (content)",
  "Üretiliyor...": "Generating...",
  "Taslak üret": "Generate draft",
  "Şablon": "Template",
  "Aç": "Open",
  "İmzasız gövdeyi kopyala (Mac Mail için)": "Copy unsigned body (for Mac Mail)",
  "İmzasız": "Unsigned",
  "İmzalı kopyala": "Copy signed",

  // ---- MailAccountsCard ----
  "Ek posta hesabı bağlandı.": "Additional mail account connected.",
  "Bu posta kutusu zaten birincil hesap olarak bağlı.": "This mailbox is already connected as the primary account.",
  "Okuma izni verilmedi; bağlanmadı.": "Read access was not granted; not connected.",
  "Güvenlik doğrulaması geçersiz; işlem iptal edildi.": "Security check invalid; the operation was cancelled.",
  "Sunucuda Google yapılandırması eksik.": "Google configuration is missing on the server.",
  "Geri dönüş isteği eksik/bozuk.": "Callback request missing/broken.",
  "Bağlantı tamamlanmadı ({p}).": "Connection not completed ({p}).",
  "Bu ek posta hesabı kaldırılsın mı? Google'daki okuma izni de iptal edilir.": "Remove this additional mail account? The Google read access will also be revoked.",
  "Ek hesap kaldırıldı": "Additional account removed",
  "İş ve kişisel posta hesaplarını buradan yönetin. Ek hesap eklemek uygulamaya giriş yetkisi vermez; yalnızca sahibin kendisi Google izin ekranından onaylar. Varsayılan hesap, asistanın araç ve otomasyonlarda hedeflediği posta kutusudur.": "Manage your work and personal mail accounts here. Adding an extra account does not grant app login; only the owner approves via the Google consent screen. The default account is the mailbox the assistant targets in tools and automations.",
  "Henüz bağlı posta hesabı yok. Yukarıdaki Gmail kartından birincil ModiHome kutusunu bağlayın.": "No connected mail account yet. Connect the primary ModiHome mailbox from the Gmail card above.",
  "varsayılan": "default",
  "gönderme açık": "sending on",
  "değiştirme açık": "modify on",
  "Varsayılan yap": "Make default",
  "Rol:": "Role:",
  "İş": "Work",
  "Kişisel": "Personal",
  "Takma ad:": "Alias:",
  "Google hesabı ekle": "Add Google account",
  "bağlantı bekliyor": "pending connection",
  "yapılandırıldı": "configured",
  "Hesap ayrımı nasıl çalışır?": "How does account separation work?",
  "Birincil ModiHome kutusu Gmail kartındaki yetkilerle (okuma, gönderme, arşiv/çöp, takvim) çalışır; ek hesaplar yalnızca okunur ve asistana giriş hakkı vermez.": "The primary ModiHome mailbox works with the permissions on the Gmail card (read, send, archive/trash, calendar); extra accounts are read-only and do not grant login to the assistant.",
  "Varsayılan hesap, \"mail var mı\" gibi sorularda ve yeni e-posta otomasyonlarında hedeflenir; başka hesabı kastederek sorarsanız (ör. \"kişisel hesabımda\") asistan ona yönelir.": "The default account is targeted for questions like \"any mail?\" and for new email automations; if you mean another account (e.g. \"in my personal account\") the assistant switches to it.",
  "Microsoft/Outlook için Azure uygulama kaydı kimlik bilgileri eklenmeden bağlantı kurulmaz.": "For Microsoft/Outlook, no connection is made until Azure app registration credentials are added.",

  // ---- MicSettingsCard / WakeWord ----
  "Uyandırma sözcüğü açıldı": "Wake word enabled",
  "Uyandırma sözcüğü kapatıldı": "Wake word disabled",
  "Bu tarayıcı ses tanımayı desteklemiyor — uyandırma sözcüğü kullanılamaz.": "This browser does not support speech recognition — the wake word cannot be used.",
  "Kapalı. Açıldığında bir kez sayfayla etkileşmeniz ve mikrofon izni vermeniz gerekir.": "Off. When enabled, you need to interact with the page once and grant microphone permission.",
  "Mikrofon izni reddedildi — tarayıcı adres çubuğundan izin verin.": "Microphone permission denied — allow it from the browser address bar.",
  "Oturum sürerken duraklatıldı (konuşma bitince tekrar dinler).": "Paused while a session is running (listens again when the conversation ends).",
  "Etkinleştirmek için sayfada bir yere dokunun/tıklayın.": "Tap/click somewhere on the page to activate.",
  "Dinlemede — 'Jarvis' deyin, konuşma başlasın.": "Listening — say 'Jarvis' to start a conversation.",
  "Hazırlanıyor…": "Preparing…",
  "Jarvis diyerek uyandır": "Wake by saying Jarvis",
  "Açıkken, sekme açıkken \"Jarvis\" dediğinizde ses oturumu kendiliğinden başlar (beklerken ücretli oturum açılmaz).": "When on, saying \"Jarvis\" while the tab is open starts a voice session on its own (no paid session opens while waiting).",
  "dinlemede": "listening",
  "Yalnızca bu sekme açık ve etkinken çalışır; sekme kapanır/uykuya geçerse durur. Arka planda veya telefon kilitliyken dinleme ": "Works only while this tab is open and active; it stops if the tab closes or sleeps. Listening in the background or while the phone is locked is ",
  "söz verilmez": "not promised",
  ". Mikrofon donanımı bu ortamda test edilmemiştir. Kapatınca dinleyici ve mikrofon erişimi tamamen bırakılır; süren bir konuşma kesilmez. Orb'a tıklayarak elle başlat/durdur her zaman çalışır.": ". The microphone hardware has not been tested in this environment. When turned off, the listener and microphone access are fully released; an ongoing conversation is not interrupted. Manual start/stop by tapping the Orb always works.",
  "Mikrofon cihazı": "Microphone device",
  "Sistem varsayılanı": "System default",
  "Mikrofon {n}": "Microphone {n}",
  "Durdur": "Stop",
  "Test et": "Test",
  "Mikrofon izni verilmedi veya cihaz bulunamadı.": "Microphone permission was not granted or no device was found.",
  "Mikrofon kaydedildi": "Microphone saved",
  "Mikrofon testi başlatılamadı.": "Could not start microphone test.",
  "Konuşun — seviye:": "Speak — level:",
  "Çubuk hareket ediyorsa mikrofon çalışıyor. Test 8 sn sonra otomatik durur.": "If the bar moves, the microphone works. The test stops automatically after 8s.",
  "\"Jarvis\" uyandırma sözcüğü yalnızca bu sekme açıkken ve bu tarayıcı oturumu boyunca dinler. Bir kez mikrofonla başlattıktan sonra, sekme açık kaldığı sürece her seferinde düğmeye basmadan \"Jarvis\" komutuna yanıt verir (kısa kesintilerde dinleme otomatik yeniden kurulur). Sekme kapanır, uyku moduna geçer veya tarayıcı sekmeyi askıya alırsa dinleme durur — arka planda veya telefon kilitliyken sürekli dinleme ": "The \"Jarvis\" wake word listens only while this tab is open and for the duration of this browser session. Once started with the microphone, as long as the tab stays open it responds to \"Jarvis\" each time without pressing a button (listening is re-established automatically after brief interruptions). If the tab closes, sleeps or the browser suspends it, listening stops — continuous listening in the background or while the phone is locked is ",
  ", mikrofon donanımı bu ortamda test edilmemiştir. Araya girme (barge-in): Jarvis konuşurken konuşmaya başlarsanız yanıt kesilir.": ", the microphone hardware has not been tested in this environment. Barge-in: if you start speaking while Jarvis is talking, the reply is interrupted.",

  // ---- ChatVoice ----
  "Sohbet sekmeleri yüklenemedi, tekrar deneniyor…": "Could not load chat tabs, retrying…",
  "Yeni sohbet": "New chat",
  "Sekme oluşturulamadı": "Could not create tab",
  "Sekme adı": "Tab name",
  "Yeniden adlandırılamadı": "Could not rename",
  "Bu sohbet sekmesi ve geçmişi silinsin mi?": "Delete this chat tab and its history?",
  "Yanıt zaman aşımına uğradı — mesajınız geri yüklendi, tekrar gönderin.": "The reply timed out — your message was restored, please send again.",
  "Mesaj gönderilemedi — mesajınız geri yüklendi.": "Could not send message — your message was restored.",
  "{name} eklendi": "{name} added",
  "Sohbet · Chat": "Chat",
  "Otomatik": "Automatic",
  "Tıkla: aç · çift tıkla: yeniden adlandır": "Click: open · double-click: rename",
  "Sekme": "Tab",
  "görsel": "image",
  "yanıt hazırlanıyor…": "preparing reply…",
  "× kaldır": "× remove",
  "gönderilemedi": "could not send",
  "Tüm sohbeti aç ›": "Open full chat ›",
  "Emergent kredisi": "Emergent credit",

  // ---- Security confirm (prompt-injection firewall) ----
  "Güvenlik onayı": "Security confirmation",
  "İşlem": "Action",
  "Tür": "Type",
  "Bu yanıtta e-posta/haber gibi güvenilmez dış içerik okundu. İşlem yalnızca bu onayla ve yukarıda gösterilen hedefte yapılır.": "Untrusted external content (email/news) was read in this reply. The action is performed only with this approval and on the target shown above.",
  "Onayla ve uygula": "Confirm and apply",
  "Onaylandı": "Confirmed",
  "Zaten uygulandı": "Already applied",
  "Enter gönderir, Shift+Enter alt satır": "Enter sends, Shift+Enter new line",
  "Ses nasıl çalışır?": "How does voice work?",
  "Akış: ses → metin": "Flow: voice → text",
  "ses": "voice",
  "Emergent kredisi kullanılır": "Runs on Emergent credit",
  "karakter": "characters",
  "Türkçe desteklenir; sesler İngilizce için optimize olduğundan hafif aksan olabilir. Araya girilebilen gerçek GPT-Live konuşma ayrı bir moddur: Ayarlar → Live konuşma. Ses ve model ayarları: Ayarlar.": "Turkish is supported; as the voices are optimised for English, a slight accent may occur. The interruptible real GPT-Live conversation is a separate mode: Settings → Live conversation. Voice and model settings: Settings.",

  // ---- RecordSpotlight ----
  "Bu teklif artık kayıtlarda yok.": "This proposal is no longer on record.",
  "Bu proje artık kayıtlarda yok.": "This project is no longer on record.",
  "Bu dosya artık kayıtlarda yok.": "This file is no longer on record.",
  "Kayıt bulunamadı.": "Record not found.",
  "Yüklenemedi (HTTP {code}).": "Could not load (HTTP {code}).",
  "Yüklenemedi — bağlantı hatası.": "Could not load — connection error.",
  "Dosya": "File",
  "{title} önizleme": "{title} preview",
  "Liste": "List",
  "Ana sahneye dön": "Back to main scene",
  "Yeni sekmede": "In new tab",
  "Teklif PDF": "Proposal PDF",
  "Bu tarayıcıda gömülü PDF görüntüleyici yok.": "This browser has no embedded PDF viewer.",
  "PDF'i yeni sekmede aç": "Open PDF in a new tab",
  "İlerleme": "Progress",
  "Bu dosya türü için önizleme yok ({ct}).": "No preview for this file type ({ct}).",
  "bilinmiyor": "unknown",

  // ---- VoiceNote ----
  "Sesli not kullanılamıyor": "Voice note unavailable",
  "Bu tarayıcı ses kaydını desteklemiyor": "This browser does not support audio recording",
  "Mikrofon izni alınamadı": "Could not get microphone permission",
  "Kayıt çok kısa": "Recording too short",
  "Konuşma algılanmadı — metin boş": "No speech detected — text is empty",
  "Yazıya çevrildi — düzenleyip Gönder'e basın": "Transcribed — edit and press Send",
  "Yazıya çevrilemedi": "Could not transcribe",
  "Sesli not: ses → metin (tek yönlü, GPT-Live değil)": "Voice note: voice → text (one-way, not GPT-Live)",
  "Yazıya çevriliyor…": "Transcribing…",
  "Sesli not": "Voice note",
  "Kaydı bitir · {s}s": "End recording · {s}s",
  "Metin önce girişe gelir; siz Gönder'e basarsınız.": "Text appears in the input first; you press Send.",

  // ---- MiscPanels: Memory ----
  "Anahtar gerekli": "Key required",
  "Yedek indirildi": "Backup downloaded",
  "Kalıcı iş hafızası — doğrulanmış vs tahmin ayrımı": "Persistent work memory — verified vs guessed distinction",
  "Dışa aktar": "Export",
  "Kategori": "Category",
  "Anahtar": "Key",
  "Değer": "Value",
  "doğrulanmış": "verified",

  // ---- MiscPanels: Usage ----
  "Gerçek API kullanımına dayalı maliyet (USD)": "Cost based on real API usage (USD)",
  "Toplam (bu hesap)": "Total (this account)",
  "Bazı kalemler tahmini / veri yok": "Some items are estimated / no data",
  "Henüz model kullanımı yok (AI bağlanınca dolacak)": "No model usage yet (fills in when AI connects)",
  "çağrı": "calls",
  "giriş tok.": "input tok.",
  "çıkış tok.": "output tok.",
  "maliyet": "cost",
  "Fiyat yapılandırması · kaynak: güncel {d}": "Pricing configuration · source: current {d}",
  "saniye: veri yok": "seconds: no data",
  "Emergent geliştirme/barındırma kredileri ile AI kullanım maliyeti ayrı kalemlerdir. Platformun gerçek bakiye API'si olmadan tahmini bakiye gösterilmez.": "Emergent development/hosting credits and AI usage cost are separate items. Without the platform's real balance API, an estimated balance is not shown.",

  // ---- MiscPanels: Notifications ----
  "Bu otomasyon kaldırılsın mı?": "Remove this automation?",
  "Otomasyon kaldırıldı": "Automation removed",
  "aktif": "active",
  "hata": "error",
  "durduruldu": "paused",
  "Arka plan e-posta takibi ve uygulama içi bildirimler": "Background email tracking and in-app notifications",
  "Otomasyonlar": "Automations",
  "Henüz otomasyon yok. Jarvis'e \"her 30 dakikada yeni maillerimi kontrol et, önemlileri haber ver\" diyebilirsin. Bildirimler yalnızca uygulama içidir.": "No automations yet. You can tell Jarvis \"check my new mail every 30 minutes and alert me to the important ones\". Notifications are in-app only.",
  "Devam": "Resume",
  "Bildirimler": "Notifications",
  "Son:": "Last:",
  "Hata:": "Error:",
  "Sonraki:": "Next:",

  // ---- MiscPanels: TTS ----
  "Hazır": "Ready",
  "Kullanılamıyor": "Unavailable",
  "otomatik okuma": "auto read",
  "Otomatik okumayı kapat": "Turn off auto read",
  "Otomatik okumayı aç": "Turn on auto read",
  "Ses": "Voice",
  "Bu akış GPT-Live değildir; insan Türkçe telaffuz değerlendirmesi henüz yapılmadı.": "This flow is not GPT-Live; a human Turkish pronunciation review has not been done yet.",

  // ---- MiscPanels: Business profile ----
  "Şirket adı": "Company name",
  "VAT numarası": "VAT number",
  "Varsayılan dil": "Default language",
  "Asistan üslubu": "Assistant tone",
  "Kısa": "Short",
  "Detaylı": "Detailed",
  "Hitap (opsiyonel)": "Address term (optional)",
  "Sessiz saat (bilgi, uygulama içi)": "Quiet hours (info, in-app)",
  "Teklif tercihleri / şartlar": "Proposal preferences / terms",
  "İmza tercihi": "Signature preference",
  "Önemli e-posta ölçütü (otomasyon sınıflandırması için)": "Important email criteria (for automation classification)",
  "Bu tercihler Hafıza ile birlikte asistanın taslak ve yanıtlarını kişiselleştirmek için kullanılır. Eksik bilgi uydurulmaz.": "These preferences, together with Memory, are used to personalise the assistant's drafts and replies. Missing information is not invented.",

  // ---- MiscPanels: Pending feeds ----
  "Haber, araştırma ve müzik kartları gerçek bir kaynağa bağlı değil. Aşağıdaki sağlayıcı bilgileri eklenene kadar asistan sahte haber/sonuç üretmez veya \"çalıyor\" göstermez — kart açıkça \"bağlı değil\" der.": "The news, research and music cards are not connected to a real source. Until the provider details below are added, the assistant does not generate fake news/results or show \"playing\" — the card clearly says \"not connected\".",
  "Araştırma (web arama)": "Research (web search)",
  "Bir web arama sağlayıcısı API anahtarı gerekir — ör. Brave Search API veya Tavily.": "A web search provider API key is required — e.g. Brave Search API or Tavily.",
  "Haberler": "News",
  "Bir haber sağlayıcısı anahtarı gerekir — ör. NewsAPI veya GNews.": "A news provider key is required — e.g. NewsAPI or GNews.",
  "Müzik": "Music",
  "Kendi müzik hesabınızla yetkilendirme gerekir — ör. Spotify (hesap OAuth'u sizin onayınızla).": "Authorisation with your own music account is required — e.g. Spotify (account OAuth with your approval).",
  "Ücretli abonelik veya yeni hesap erişimi otomatik açılmaz; sağlayıcı ve kimlik bilgilerini siz onaylarsınız.": "A paid subscription or new account access is not opened automatically; you approve the provider and credentials.",

  // ---- MiscPanels: Settings general ----
  "Sistemin \"hareketi azalt\" tercihine her zaman uyulur.": "The system's \"reduce motion\" preference is always respected.",
  "Harcama sınırı (USD)": "Spending limit (USD)",
  "Günlük": "Daily",
  "Aylık": "Monthly",
  // ---- scene widget cards / research / chat sources (local repair 2026-10) ----
  "Yeni özet yok.": "No new summary.",
  "okunmamış": "unread",
  "Yaklaşan etkinlik yok.": "No upcoming events.",
  "Araştırma sonucu bulunamadı.": "No research result found.",
  "Kaynaklara ulaşılamadıysa kısa süre sonra tekrar deneyin.": "If the sources could not be reached, try again shortly.",
  "Müzik servisi bağlı değil. Çalma için kendi müzik hesabınızla bağlantı gerekir (ör. Spotify hesap yetkilendirmesi). Ayarlar → Bağlantılar'dan hazırlanır — çalıyormuş gibi gösterilmez.": "No music service is connected. Playback needs your own music account (e.g. Spotify authorisation), prepared in Settings → Connections — nothing is shown as playing.",
  "Toplam": "Total",
  "bugün": "today",
  "Kaynak: yayıncı RSS akışları · çekilme:": "Source: publisher RSS feeds · fetched:",
  "Dünya": "World",
  "İngiltere": "UK",
  "Türkiye": "Türkiye",
  "Kaynaklar": "Sources",
  "Web araması platform (Emergent) modunda desteklenmiyor. Ayarlar → Yapay zekâ bağlantısı'ndan kendi OpenAI anahtarı modunu seçin.": "Web search is not supported in platform (Emergent) mode. Choose your own OpenAI key mode in Settings → AI connection.",
  "Yanıt alındı ancak kaynak bağlantısı içermiyor; doğrulanmamış kabul edin.": "An answer arrived but without source links; treat it as unverified.",
  "Güncel web araması için sunucuda kendi OpenAI API anahtarı (OPENAI_API_KEY) gerekir.": "Live web search needs your own OpenAI API key (OPENAI_API_KEY) on the server.",
  "Güncel web araması için kendi OpenAI API anahtarı modu gerekli (Ayarlar → Yapay zekâ bağlantısı). Platform/Emergent modunda web araması yoktur.": "Live web search needs your own OpenAI API key mode (Settings → AI connection). There is no web search in platform/Emergent mode.",
  "Web araması zaman aşımına uğradı; tekrar deneyin.": "Web search timed out; try again.",
  "Web araması kullanılamıyor.": "Web search is unavailable.",
  "Araştırma konusu belirtilmedi; ücretli arama yapılmadı.": "No research topic was given; no paid search was made.",
  // ---- Settings feeds card ----
  "Asistan sahte haber/sonuç üretmez veya \"çalıyor\" göstermez; bağlı olmayan kaynak kartta açıkça belirtilir.": "The assistant never fabricates news/results or shows \"playing\"; an unconnected source is stated clearly on its card.",
  "Yazışma: kendi OpenAI anahtarı modunda web araması hazır.": "Chat: web search is ready in own OpenAI key mode.",
  "Yazışma: platform (Emergent) modunda web araması yok; Sohbet sekmesinden kendi OpenAI anahtarı modunu seçin.": "Chat: no web search in platform (Emergent) mode; choose own OpenAI key mode in the Chat tab.",
  "Yazışma: sunucuda OPENAI_API_KEY yok.": "Chat: OPENAI_API_KEY is not set on the server.",
  "Live konuşma: kendi OpenAI anahtarınızla hazır.": "Live conversation: ready with your own OpenAI key.",
  "Live konuşma: sunucuda OPENAI_API_KEY yok.": "Live conversation: OPENAI_API_KEY is not set on the server.",
  "Arama yalnızca siz açıkça araştırma istediğinizde yapılır (ücretli).": "A search runs only when you explicitly ask for research (paid).",
  "hazır": "ready",
  "Ücretsiz güvenilir yayıncı RSS akışları (Dünya / İngiltere / Türkiye). Konu bazlı haber için araştırma kullanılır.": "Free trusted publisher RSS feeds (World / UK / Türkiye). Topic news uses research.",
  // ---- AI connection card (backend option labels / status messages, exact strings) ----
  "Kendi OpenAI API anahtarım": "My own OpenAI API key",
  "Emergent kredileri (Universal Key)": "Emergent credits (Universal Key)",
  "OpenAI hesabınıza (kullanım bazlı)": "Billed to your OpenAI account (usage based)",
  "Emergent kredi bakiyeniz": "Your Emergent credit balance",
  "OPENAI_API_KEY sunucuda tanımlı değil. Sunucu secrets alanına ekleyip yeniden başlatın; anahtar sohbet kutusuna yazılmaz, loglanmaz ve istemciye gönderilmez.": "OPENAI_API_KEY is not set on the server. Add it to the server secrets and restart; the key is never typed into chat, logged or sent to the browser.",
  "EMERGENT_LLM_KEY sunucuda tanımlı değil. Sunucu secrets alanına ekleyip yeniden başlatın; anahtar sohbet kutusuna yazılmaz, loglanmaz ve istemciye gönderilmez.": "EMERGENT_LLM_KEY is not set on the server. Add it to the server secrets and restart; the key is never typed into chat, logged or sent to the browser.",
  "OpenAI'ye ulaşılamadı (ağ hatası). Sunucu bağlantısını kontrol edin.": "Could not reach OpenAI (network error). Check the server connection.",
  "Görsel analizi yalnızca kendi OpenAI anahtarı modunda gönderilir; Emergent kredi modunda görsel sunucuya iletilmez.": "Image analysis is only sent in own OpenAI key mode; in Emergent credit mode the image is not forwarded.",
  // ---- Mail accounts / Outlook ----
  "Sunucu yapılandırması mevcut.": "Server configuration present.",
  "Henüz bağlı değil — kurulum için Azure uygulama kaydı gerekir.": "Not connected yet — setup needs an Azure app registration.",
  "Teknik yapılandırma": "Technical configuration",
  // ---- Voice settings (compact) ----
  "Yalnızca bu sekme açık ve etkinken dinler; arka planda veya kilitli ekranda dinleme yoktur.": "Listens only while this tab is open and active; no background or locked-screen listening.",
  "Ses ayrıntıları": "Voice details",
  "Sekme kapanır, uykuya geçer veya tarayıcı sekmeyi askıya alırsa dinleme durur; kısa kesintilerde otomatik yeniden kurulur.": "Listening stops if the tab closes, sleeps or is suspended by the browser; short interruptions re-arm automatically.",
  "Kapatınca dinleyici ve mikrofon erişimi tamamen bırakılır; süren bir konuşma kesilmez. Orb'a tıklayarak elle başlat/durdur her zaman çalışır.": "Turning it off fully releases the recognizer and microphone; an ongoing conversation is not cut. Tapping the orb always starts/stops manually.",
  "Mikrofon donanımı bu ortamda test edilmemiştir.": "Microphone hardware has not been tested in this environment.",
  "Araya girme (barge-in): Jarvis konuşurken konuşmaya başlarsanız yanıt kesilir.": "Barge-in: if you start speaking while Jarvis is talking, the reply stops.",

  // ---- expansion §1–§8 (AI & voice, integrations, map, workflows) ----
  "bağlı değil": "not connected",
  "bağlı": "connected",
  "doğrulandı": "verified",
  "test başarısız": "test failed",
  "yapılandırıldı · test edilmedi": "configured · not tested",
  "AI yapılandırıldı · test edilmedi": "AI configured · not tested",
  "Platform": "Platform",
  "API bağlantılarım": "My API connections",
  "AI PC'm": "My AI PC",
  "Platform (Emergent)": "Platform (Emergent)",
  "Claude (Anthropic)": "Claude (Anthropic)",
  "AI PC": "AI PC",
  "Sohbet kaynağı kaydedildi": "Chat source saved",
  "Test başarısız": "Test failed",
  "Anahtar sunucuda saklandı": "Key stored on the server",
  "Anahtar kaldırıldı": "Key removed",
  "Sunucu ortam değişkenindeki anahtar hâlâ etkin.": "The key in the server environment is still active.",
  "Ayarlar yüklenemedi.": "Settings could not be loaded.",
  "Sohbet zekâsı": "Chat intelligence",
  "Test edilen": "Tested",
  "Bağlantılar": "Connections",
  "Anahtar sunucu ortamında tanımlı.": "Key is defined in the server environment.",
  "Kayıtlı anahtarı değiştir": "Replace saved key",
  "API anahtarı": "API key",
  "Kaldır": "Remove",
  "AI PC uç noktası": "AI PC endpoint",
  "Bu model araç çağrısını destekliyor (kayıt arama, ekran açma)": "This model supports tool calling (record search, opening screens)",
  "Sesli konuşma": "Voice conversation",
  "GPT Live": "GPT Live",
  "Standart ses": "Standard voice",
  "Ses kapalı": "Voice off",
  "Ses kapalı — Ayarlar → Yapay zekâ ve ses'ten açabilirsiniz.": "Voice is off — turn it on in Settings → AI and voice.",
  "Ses seçimi sohbet kaynağından bağımsızdır; değiştirmek oturum açmaz.": "Voice choice is independent of the chat source; changing it opens no session.",
  "Görsel": "Images",
  "Araçlar": "Tools",
  "modele bağlı": "model-dependent",
  "Web araştırması": "Web research",
  "Anahtar kaynağı": "Key source",
  "sunucu ortamı": "server environment",
  "ayarlarda kayıtlı": "saved in settings",
  "AI PC isteği JARVIS sunucusundan gider: 'localhost' bu sunucudur, ayrı AI PC değil. Aynı makine: http://127.0.0.1:1234/v1 (LM Studio) veya :11434/v1 (Ollama). Ayrı PC: yerel ağ IP'si. İzinli portlar": "AI PC requests come from the JARVIS server: 'localhost' is this server, not a separate AI PC. Same machine: http://127.0.0.1:1234/v1 (LM Studio) or :11434/v1 (Ollama). Separate PC: its LAN IP. Allowed ports",
  "Port açma, güvenlik duvarı veya yönlendirici değişikliği yapılmaz.": "No ports are opened and no firewall or router changes are made.",
  "AI PC seçmek GPT Live, uyandırma sözcüğü, çevrimdışı ses tanıma/okuma veya web araştırması sağlamaz; bunlar ayrı kaynaklardır.": "Choosing the AI PC does not provide GPT Live, the wake word, offline speech recognition/reading or web research; those are separate sources.",
  "ChatGPT Plus veya Claude Pro aboneliği API anahtarı değildir; burada yalnızca sağlayıcı API anahtarı kullanılır.": "A ChatGPT Plus or Claude Pro subscription is not an API key; only provider API keys are used here.",
  "Kaynak çalışmazsa önerilecek yedek": "Fallback to suggest if the source fails",
  "Yok (sor)": "None (ask)",
  "Yedek kaynak asla otomatik kullanılmaz; hata olduğunda yalnızca düğme olarak önerilir.": "A fallback source is never used automatically; on error it is only offered as a button.",
  "Kendi Claude (Anthropic) API anahtarım": "My own Claude (Anthropic) API key",
  "Anthropic API hesabınıza (kullanım bazlı; Claude Pro aboneliği API bakiyesi değildir)": "Billed to your Anthropic API account (usage based; a Claude Pro subscription is not API balance)",
  "Yerel donanım (API ücreti yok)": "Local hardware (no API fee)",
  "AI PC (yerel model)": "AI PC (local model)",
  "AI PC uç noktası ayarlanmadı.": "AI PC endpoint is not set.",
  "Sunucu yanıt verdi ama yüklü model yok (LM Studio'da bir model yükleyin).": "The server responded but no model is loaded (load a model in LM Studio).",
  "Yerel yapay zekâ sunucusuna ulaşılamadı (kapalı, yanlış adres veya bu sunucudan erişilemiyor).": "Could not reach the local AI server (off, wrong address or not reachable from this server).",
  "Yapay zekâ ve ses": "AI and voice",
  "Bu mesajı şununla tekrar gönder": "Resend this message with",
  "yanıt durduruldu": "reply stopped",
  "Model": "Model",
  "Gönder": "Send",
  "Dinle": "Listen",
  "Henüz sabah özeti yok.": "No morning brief yet.",
  "Sesli okuma kullanılamıyor; metin gösteriliyor.": "Read-aloud is unavailable; showing the text.",
  "Özet alınamadı": "Could not get the brief",
  "Sabah özeti": "Morning brief",
  "Spotify": "Spotify",
  "WhatsApp": "WhatsApp",
  "Spotify bağlandı.": "Spotify connected.",
  "Spotify izin ekranında onay verilmedi.": "Consent was not given on the Spotify screen.",
  "Spotify kod değişimi başarısız; tekrar deneyin.": "Spotify code exchange failed; try again.",
  "Spotify hesabı doğrulanamadı.": "Spotify account could not be verified.",
  "Sunucuda Spotify yapılandırması eksik.": "Spotify configuration is missing on the server.",
  "Spotify bağlantısı tamamlanmadı.": "Spotify connection was not completed.",
  "Bağlantı kesildi": "Disconnected",
  "Durum alınamadı.": "Status could not be loaded.",
  "Spotify'ı bağla": "Connect Spotify",
  "Hesap Premium değil: arama ve durum çalışır, çalma kontrolü Spotify kuralı gereği çalışmaz.": "Account is not Premium: search and status work; playback control does not (Spotify rule).",
  "Sunucuda Spotify geliştirici uygulaması yapılandırılmadı.": "No Spotify developer app is configured on the server.",
  "Spotify Developer uygulaması (Client ID + Redirect URI)": "A Spotify Developer app (Client ID + Redirect URI)",
  "Çalma kontrolü için Spotify Premium": "Spotify Premium for playback control",
  "Etkin bir Spotify cihazı (uygulama açık)": "An active Spotify device (app open)",
  "Durum her zaman Spotify'dan okunur; 'çalıyor' bilgisi uydurulmaz. Yenileme anahtarı yalnızca sunucuda tutulur.": "State is always read from Spotify; 'playing' is never invented. The refresh token stays on the server.",
  "Yerel Spotify anahtarları silindi. Spotify tarafındaki izni https://www.spotify.com/account/apps/ adresinden de kaldırabilirsiniz.": "Local Spotify tokens were deleted. You can also remove the grant at https://www.spotify.com/account/apps/.",
  "Spotify bağlı değil. Ayarlar → Bağlantılar → Spotify'dan bağlayın — çalıyormuş gibi gösterilmez.": "Spotify is not connected. Connect it in Settings → Connections → Spotify — nothing is shown as playing.",
  "Etkin Spotify cihazı yok (Spotify uygulaması açık değil).": "No active Spotify device (the Spotify app is not open).",
  "Çalma kontrolü Spotify Premium gerektirir (Spotify kuralı). Arama ve durum okuma çalışır; çalma/duraklatma için Premium hesap gerekir.": "Playback control requires Spotify Premium (Spotify rule). Search and status work; play/pause need a Premium account.",
  "Etkin bir Spotify cihazı yok. Telefonda/bilgisayarda Spotify uygulamasını açıp bir kez çalmaya başlayın, sonra tekrar deneyin.": "No active Spotify device. Open the Spotify app on a phone/computer, start playing once, then try again.",
  "çalıyor": "playing",
  "duraklatıldı": "paused",
  "Çal": "Play",
  "Duraklat": "Pause",
  "Sonraki": "Next",
  "Önceki": "Previous",
  "İş numarası hesabınıza bağlandı": "Business number linked to your account",
  "İş numarası bağlı": "Business number connected",
  "Bu iş numarasını bağla": "Link this business number",
  "Henüz gelen mesaj yok.": "No incoming messages yet.",
  "Kişisel WhatsApp hesapları için resmî API yoktur; kişisel sohbetler JARVIS'e bağlanamaz.": "There is no official API for personal WhatsApp accounts; personal chats cannot be connected to JARVIS.",
  "Yalnızca WhatsApp Business Platform (Cloud API) numarası bağlanabilir (Meta Business + uygulama + kayıtlı numara).": "Only a WhatsApp Business Platform (Cloud API) number can be connected (Meta Business + app + registered number).",
  "Kişisel numaranızı Cloud API'ye taşımak o numaradaki normal WhatsApp kullanımını etkileyebilir; ayrı bir iş numarası önerilir.": "Moving your personal number to the Cloud API can affect normal WhatsApp use on that number; a separate business number is recommended.",
  "Serbest metin yanıt yalnızca kişinin son mesajından sonraki 24 saat içinde gönderilebilir; dışında onaylı şablon gerekir (uygulanmadı).": "Free-form replies are only allowed within 24 hours of the contact's last message; outside it an approved template is required (not implemented).",
  "WhatsApp Business uygulaması 'coexistence' seçeneği bu ortamda doğrulanmadı; varsayılmadı.": "The WhatsApp Business app 'coexistence' option was not verified in this environment and is not assumed.",
  "Gönderim yalnızca taslak → ekranda onay → tek kullanımlık token ile yapılır.": "Sending only happens via draft → on-screen confirmation → single-use token.",
  "Sabah özeti hazırlandı — Bildirimler'de Dinle": "Morning brief prepared — Listen in Notifications",
  "Özet hazırlanamadı": "Could not prepare the brief",
  "Her gün": "Every day",
  "Saat": "Time",
  "Şimdi hazırla": "Prepare now",
  "Tarayıcı kapalıyken özet sunucuda hazırlanır ve bildirim olarak kaydedilir; sesli okuma yalnızca 'Dinle' dediğinizde olur.": "With the browser closed, the brief is prepared on the server and saved as a notification; it is only read aloud when you press 'Listen'.",
  "Outlook hesabı bağlandı.": "Outlook account connected.",
  "Microsoft izin ekranında onay verilmedi.": "Consent was not given on the Microsoft screen.",
  "Microsoft kod değişimi başarısız; tekrar deneyin.": "Microsoft code exchange failed; try again.",
  "Verilen Microsoft izni fazla geniş olduğu için bağlanmadı.": "Not connected because the granted Microsoft permission was too broad.",
  "Okuma izni verilmedi; bağlanmadı.": "Read permission was not granted; not connected.",
  "Microsoft hesabı doğrulanamadı; bağlanmadı.": "Microsoft account could not be verified; not connected.",
  "Farklı bir Microsoft hesabıyla giriş yapıldı; izin güncellenmedi.": "A different Microsoft account signed in; permissions were not updated.",
  "Sunucuda Microsoft yapılandırması eksik.": "Microsoft configuration is missing on the server.",
  "Değiştirmeyi etkinleştir": "Enable changes",
  "Kişisel (Outlook.com/Hotmail) veya iş hesabı ekleyebilirsiniz; önce yalnızca okuma izni istenir.": "You can add a personal (Outlook.com/Hotmail) or work account; only read permission is requested first.",
  "Outlook hesabı ekle": "Add Outlook account",
  "Microsoft/Outlook bağlantısı için Azure uygulama kaydı gerekir (AZURE_CLIENT_ID, AZURE_CLIENT_SECRET, AZURE_REDIRECT_URI; AZURE_TENANT_ID boşsa 'common'). Bu kimlik bilgileri eklenene kadar bağlantı kurulamaz; bağlıymış gibi gösterilmez.": "Microsoft/Outlook needs an Azure app registration (AZURE_CLIENT_ID, AZURE_CLIENT_SECRET, AZURE_REDIRECT_URI; AZURE_TENANT_ID defaults to 'common'). Until these are added no connection is possible and nothing is shown as connected.",
  "Vade tarihi": "Due date",
  "Hatırlatma taslağı hazır — E-postalar'da onaylayın": "Reminder draft ready — confirm it in Emails",
  "gün gecikmiş": "days overdue",
  "kısmi ödendi": "partially paid",
  "Hatırlatma taslağı": "Reminder draft",
  "ödenmemiş · vade tarihi kayıtlı değil": "unpaid · no due date recorded",
  "faturalanmamış tamamlanmış iş": "uninvoiced completed work",
  "Notlar · kapsam · proje hafızası": "Notes · scope · project memory",
  "Notlar": "Notes",
  "Hafıza": "Memory",
  "Fotoğraftan taslak": "Draft from photos",
  "Örn: Banyo fayansı bitti, derz kaldı, 2 torba yapıştırıcı lazım": "E.g. bathroom tiles done, grout remaining, need 2 bags of adhesive",
  "Şantiye notu": "Site note",
  "Notu kaydet": "Save note",
  "Önerilenler (yalnızca onayınızla uygulanır):": "Suggestions (applied only with your approval):",
  "Seçilenleri uygula": "Apply selected",
  "Uygulandı": "Applied",
  "Not düzeltildi": "Note corrected",
  "asistan": "assistant",
  "yazı": "text",
  "düzeltildi": "corrected",
  "düzelt": "correct",
  "İptal": "Cancel",
  "Onaylayan": "Approved by",
  "Kapsam kalemi": "Scope item",
  "Onaylayan kişi": "Approver",
  "Onay tarihi": "Approval date",
  "Onay kaynağı": "Approval source",
  "Ekle": "Add",
  "Müşterinin yeni isteği…": "Client's new request…",
  "Yeni istek": "New request",
  "Kapsamda mı?": "In scope?",
  "Onaylı kapsamda.": "Within the approved scope.",
  "Onaylı kapsamda değil — 'talep edildi' olarak kaydedildi ve fiyat/onay taslağı hazırlandı (gönderilmedi).": "Not in the approved scope — recorded as 'requested' and a price/approval draft was prepared (not sent).",
  "Taslağı aç": "Open draft",
  "taslağı aç": "open draft",
  "Proje hafızası alınamadı.": "Project memory could not be loaded.",
  "eski sürüm": "superseded",
  "E-posta dahil edilmedi.": "E-mail not included.",
  "Bu projeye yüklenmiş fotoğraf yok (Dosyalar ekranından yükleyin).": "No photos uploaded for this project (upload them in Files).",
  "Ölçüler (satır başına): Duvar A: 3.2 x 2.4 m": "Dimensions (one per line): Wall A: 3.2 x 2.4 m",
  "Ölçüler": "Dimensions",
  "Teklif taslağı hazırla": "Prepare proposal draft",
  "Yalnızca görsel destekli kaynakta (kendi OpenAI/Claude API) çalışır. Ölçüsü verilmeyen kalemler işaretlenir, uydurulmaz. Taslak bağlayıcı değildir ve gönderilmez.": "Works only with a vision-capable source (own OpenAI/Claude API). Items without given dimensions are flagged, never invented. The draft is non-binding and is not sent.",
  "Ölçü gerekli": "Measurement needed",
  "taslak": "draft",
  "çıkarım": "inferred",
  "talep edildi": "requested",
  "onaylandı": "approved",
  "yüz yüze": "in person",
  "telefon": "phone",
  "imzalı belge": "signed document",
  "teklif kabulü": "proposal accepted",
  "mesaj": "message",
  "not": "note",
  "görev": "task",
  "teklif": "proposal",
  "fatura": "invoice",
  "rapor": "report",
  "kapsam": "scope",

  // ---- confirmations ----
  "Onay uygulanamadı; işlemi yeniden isteyin.": "The confirmation could not be applied; please request the action again.",
  "Onay bulunamadı, süresi doldu veya zaten kullanıldı.": "Confirmation not found, expired or already used.",
  "Onay süresi doldu; işlemi yeniden isteyin.": "The confirmation expired; please request the action again.",
  "Bu idempotency anahtarı başka bir onay için kullanıldı.": "This idempotency key was already used for another confirmation.",
  // ---- dashboard chrome / voice controls ----
  "İşler": "Work",
  "İletişim": "Communication",
  "Belgeler": "Documents",
  "Sistem": "System",
  "Favoriler": "Favourites",
  "Menü": "Menu",
  "Asistan": "Assistant",
  "Favorilere ekle/çıkar": "Add/remove favourite",
  "Çıkış": "Logout",
  "Asistana dön": "Back to assistant",
  "Yazışmayı kapat": "Close chat",
  "Jarvis ile konuş": "Talk to Jarvis",
  "Sohbet": "Chat",
  "AI bakiye yetersiz": "AI balance too low",
  "AI anahtar yok": "AI key missing",
  "AI anahtar geçersiz": "AI key invalid",
  "AI erişim doğrulanmadı": "AI access not verified",
  "Kayıt sürüyor — önce 'Kaydı bitir' deyin.": "Recording in progress — say 'Kaydı bitir' (finish recording) first.",
  "Konuşmayı durdur": "Stop conversation",
  "Tekrar dene": "Try again",
  "Emergent kredili ses moduna dön": "Switch back to Emergent-credit voice mode",
  "tekrar denemek için JARVIS'e dokunun": "tap JARVIS to try again",

  "Boş = sınırsız. Bu sınır AI kullanım maliyeti içindir (OpenAI kendi anahtarınızda USD, Emergent modunda kredi ayrı sayılır). Devam eden istekler ve geciken kullanım kayıtları sınırı küçük miktarda aşabilir.": "Empty = unlimited. This limit is for AI usage cost (USD on your own OpenAI key; in Emergent mode credit is counted separately). In-flight requests and delayed usage records may exceed the limit slightly.",

  // Finance / business flow / Apple Music (Oct 2026)
  "Zaten gönderilmişti": "Already sent",
  "Kimden": "From",
  "Kime": "To",
  "Ekler": "Attachments",
  "Bu e-posta yalnızca bu onayla gönderilir. Bağlı kayıt (teklif/fatura/bakiye) gönderimden hemen önce yeniden kontrol edilir.": "This e-mail is sent only with this confirmation. The linked record (quote/invoice/balance) is re-checked immediately before sending.",
  "Tedarikçi / firma": "Supplier / payee",
  "Göster": "Show",
  "Bu aralıkta kayıt yok.": "No records in this range.",
  "Para birimleri çevrilmez": "Currencies are not converted",
  "Kesilen faturalar (tahakkuk)": "Invoiced (accrual view)",
  "net": "net",
  "kredi notu": "credit note",
  "Tahsil edilen nakit (banka)": "Cash collected (bank)",
  "faturalara eşlenen": "allocated to invoices",
  "iadeler": "refunds",
  "diğer": "other",
  "Nakit çıkışı / giderler": "Cash out / expenses",
  "net nakit akışı": "net cash flow",
  "transfer hariç": "transfers excluded",
  "bekleyen hariç": "pending excluded",
  "ödenmemiş": "unpaid",
  "kısmi": "partial",
  "ödendi": "paid",
  "iptal": "cancelled",
  "Kategoriye göre": "By category",
  "Tedarikçiye göre": "By supplier",
  "Proje maliyet ve kâr": "Project cost and margin",
  "fatura net": "invoiced net",
  "atanan maliyet": "attributed costs",
  "maliyet atanmadı": "no costs attributed",
  "İnceleme bekleyenler": "Awaiting review",
  "Dışa aktar (muhasebe için)": "Export (for bookkeeping)",
  "Banka hareketleri": "Bank transactions",
  "Faturalar": "Invoices",
  "Ödemeler": "Payments",
  "Teklifler": "Quotes",
  "Dışa aktarımlar formül enjeksiyonuna karşı güvenlidir; tutarlar 2 ondalıklı sabit sayıdır.": "Exports are safe against formula injection; amounts are fixed 2-decimal numbers.",
  "Yükleniyor...": "Loading...",
  "E-posta kimliği girin": "Enter the e-mail id",
  "Fatura kesilsin mi? Numara verilir ve PDF kilitlenir; bu numara bir daha kullanılmaz.": "Issue this invoice? A number is assigned and the PDF is locked; the number will never be reused.",
  "Düzeltme gerekçesi (kredi notu kesilir, yeni taslak açılır):": "Reason for correction (a credit note is issued and a new draft is opened):",
  "Bu projedeki iş tamamlandı olarak işaretlensin mi?": "Mark the work on this project as completed?",
  "Fatura kesmek için eksik bilgiler (Ayarlar → Benim işim → Fatura bilgileri):": "Missing details for issuing invoices (Settings → My business → Billing details):",
  "Teklif yok — Teklifler ekranından oluşturun.": "No quotes — create one on the Proposals screen.",
  "kilitli": "locked",
  "Onay": "Approval",
  "Yeniden gönder": "Resend",
  "PDF + gönder": "PDF + send",
  "Onayı elle kaydet": "Record approval manually",
  "Ek iş": "Variation",
  "Fatura taslağı": "Invoice draft",
  "Müşteri yanıtının e-posta kimliği": "E-mail id of the client's reply",
  "Onayı kontrol et": "Check approval",
  "Açık onay bulundu — teklif onaylandı.": "Explicit approval found — quote approved.",
  "İnceleme gerekli — otomatik onaylanmadı.": "Review needed — not approved automatically.",
  "Sınıf": "Class",
  "İnceledim, onay olarak kaydet": "I reviewed it, record as approval",
  "Onayı kaydet": "Save approval",
  "Onayı yalnızca siz kaydedebilirsiniz; kaynak, onaylayan kişi ve tarih zorunludur.": "Only you can record an approval; source, approver and date are required.",
  "Kaynak": "Source",
  "Tarih": "Date",
  "Kaynak referansı": "Source reference",
  "İş tamamlama": "Work completion",
  "İş tamamlandı": "Work completed",
  "Kes (numara ver)": "Issue (assign number)",
  "Ödenmemiş fatura yok.": "No unpaid invoices.",
  "vade": "due",
  "kalan": "remaining",
  "gönderildi": "sent",
  "Düzelt": "Correct",
  "Kapalıları gizle": "Hide closed",
  "Ödenen / iptal / kredi notlarını göster": "Show paid / cancelled / credit notes",
  "Açık hatırlatmalar": "Open reminders",
  "Hatırlatmalar otomatik gönderilmez. Gönderimden hemen önce bakiye yeniden okunur; ödenmişse gönderilmez.": "Reminders are never sent automatically. The balance is re-read right before sending; if paid, nothing is sent.",
  "Hesap ve dosya seçin": "Choose an account and a file",
  "yinelenen atlandı": "duplicates skipped",
  "otomatik eşlenen": "auto-matched",
  "Tutar girin": "Enter an amount",
  "Ödeme eşlendi": "Payment matched",
  "Geri çevrilen orijinal ödemenin hareket kimliği:": "Transaction id of the original payment that was reversed:",
  "Geri çevirme kaydedildi; fatura yeniden açıldı": "Reversal recorded; invoice re-opened",
  "Sağlayıcı bağlı (salt-okunur)": "Provider connected (read-only)",
  "Banka sağlayıcısı bağlı değil": "No bank provider connected",
  "Yalnızca okuma · ödeme/transfer yok": "Read-only · no payments/transfers",
  "Hesaplar": "Accounts",
  "veri yok": "no data",
  "Hesap adı": "Account name",
  "Para birimi": "Currency",
  "Hesap ekle": "Add account",
  "Ekstre içe aktar (CSV / Excel)": "Import statement (CSV / Excel)",
  "Hesap": "Account",
  "Hesap seçin": "Choose account",
  "Önizle": "Preview",
  "Eşlemeyle önizle": "Preview with mapping",
  "yinelenen": "duplicate",
  "hatalı": "invalid",
  "bekleyen": "pending",
  "Onayla ve içe aktar": "Confirm and import",
  "Ödeme eşleme incelemesi": "Payment matching review",
  "İnceleme bekleyen ödeme yok.": "No payments awaiting review.",
  "eşlenebilir kalan": "allocatable remainder",
  "Eşlenecek tutar": "Amount to allocate",
  "Eşle": "Allocate",
  "Fatura ödemesi değil": "Not an invoice payment",
  "Otomatik 'Ödendi' yalnızca tek ve referansı doğrulanmış tam ödemede yapılır; kısmi, fazla, çoklu veya farklı para birimli ödemeler sizin onayınızı bekler.": "Automatic 'Paid' happens only for a single, reference-confirmed full payment; partial, over-, multi-invoice or other-currency payments wait for your review.",
  "Kategori / transfer / iade incelemesi": "Category / transfer / refund review",
  "İnceleme bekleyen hareket yok.": "No transactions awaiting review.",
  "Geri çevirme olarak onayla": "Confirm as reversal",
  "Proje yok": "No project",
  "Transfer": "Transfer",
  "Her kategori değişikliği önceki değeriyle birlikte denetim kaydına yazılır.": "Every category change is written to the audit log with its previous value.",
  "Son e-postaları tara": "Scan recent e-mails",
  "E-posta kimliği": "E-mail id",
  "E-postadan çıkar": "Extract from e-mail",
  "Sipariş numarası olmayan e-postalardan kayıt oluşturulmaz; belirsiz tarihler işaretlenir, uydurulmaz. Kurye entegrasyonu yoktur.": "No record is created from e-mails without an order number; uncertain dates are flagged, never invented. There is no courier integration.",
  "Siparişler": "Orders",
  "Kayıtlı sipariş yok.": "No orders recorded.",
  "tarih belirsiz": "date uncertain",
  "tarih yok": "no date",
  "Teslim tarihi": "Delivery date",
  "Takip e-postası": "Follow-up e-mail",
  "Tedarikçi": "Supplier",
  "Sipariş no": "Order no",
  "Tedarikçi e-postası": "Supplier e-mail",
  "Elle ekle": "Add manually",
  "Dosya seçin": "Choose a file",
  "atlandı": "skipped",
  "Geçmiş Excel / CSV içe aktar": "Import historical Excel / CSV",
  "Veri türü": "Data type",
  "Giderler": "Expenses",
  "Zorunlu sütunlar eşlenmedi:": "Required columns not mapped:",
  "Olası banka yinelenenlerini de ekle (önerilmez)": "Also add possible bank duplicates (not recommended)",
  "İçe aktarma mevcut kayıtların üzerine yazmaz ve kaynak dosyayı değiştirmez; yinelenenler atlanır.": "Import never overwrites existing records or changes the source file; duplicates are skipped.",
  "Özet": "Summary",
  "Teklif → Fatura": "Quote → Invoice",
  "Banka": "Bank",
  "Tedarikçiler": "Suppliers",
  "İçe aktar": "Import",
  "Finans": "Finance",
  "Teklif, fatura, ödeme eşleme, raporlar ve teslimatlar · yönetim görünümü": "Quotes, invoices, payment matching, reports and deliveries · management view",
  "Bu ekran ne yapar, ne yapmaz?": "What this screen does and does not do",
  "Para transferi veya ödeme başlatma yoktur; banka verisi yalnızca okunur.": "No money transfers or payment initiation; bank data is read-only.",
  "E-postalar yalnızca inceleme + tek kullanımlık onayla gönderilir; hatırlatmalar otomatik gönderilmez.": "E-mails are sent only after review + single-use confirmation; reminders are never sent automatically.",
  "Raporlar yönetim amaçlıdır; yasal/vergi muhasebesi değildir.": "Reports are for management only; not statutory/tax accounting.",
  "Fatura kesmek için eksik:": "Missing for invoicing:",
  "Kayıtlı adres": "Registered address",
  "KDV (VAT) durumu": "VAT status",
  "Ayarlanmadı": "Not set",
  "KDV kayıtlı": "VAT registered",
  "KDV kayıtlı değil": "Not VAT registered",
  "Bu VAT numarasını HMRC kaydımdan doğruladım": "I have verified this VAT number against my HMRC record",
  "Bu bilgiler yalnızca faturalarda kullanılır ve sizin girdiğiniz şekliyle basılır; JARVIS şirket, banka veya VAT bilgisi uydurmaz. Değişiklikler denetim kaydına yazılır (banka numaraları maskelenir).": "These details are used only on invoices, printed exactly as you entered them; JARVIS never invents company, bank or VAT details. Changes are audited (bank numbers masked).",
  "Kapalı": "Off",
  "Müzik sağlayıcısı": "Music provider",
  "Asistanın müzik komutları seçili sağlayıcıya gider. Seçim çalmayı başlatmaz.": "The assistant's music commands go to the selected provider. Choosing does not start playback.",
  "bağlı (bu tarayıcı)": "connected (this browser)",
  "bu oturumda doğrulanmadı": "not verified in this session",
  "Apple Music'i bağla": "Connect Apple Music",
  "Sunucuda Apple Music (MusicKit) anahtarı yapılandırılmadı.": "No Apple Music (MusicKit) key is configured on the server.",
  "Daha önce bağlanmıştı; durumu doğrulamak için yeniden bağlanın (MusicKit bu sayfada henüz yüklenmedi).": "Connected before; reconnect to verify (MusicKit is not loaded on this page yet).",
  "Geliştirici jetonu sunucuda imzalanır; özel anahtar tarayıcıya gönderilmez. Kullanıcı jetonu yalnızca bu tarayıcıda MusicKit içinde kalır.": "The developer token is signed on the server; the private key never reaches the browser. The user token stays inside MusicKit in this browser only.",
  "Apple Music bu tarayıcıda bağlı değil — çalıyormuş gibi gösterilmez.": "Apple Music is not connected in this browser — nothing is shown as playing.",
  "Kilitli · Finans'ta yönet": "Locked · manage in Finance",
  "Finans'ta yönet": "Manage in Finance",
  "Fatura bilgileri · yasal ad, adres, VAT, banka": "Billing details · legal name, address, VAT, bank",
  "Apple Music": "Apple Music",
  "Şirket yasal adı": "Company legal name",
  "Ticari ad": "Trading name",
  "Companies House no": "Companies House no",
  "Fatura e-postası": "Billing e-mail",
  "Ödeme vadesi (gün)": "Payment terms (days)",
  "Banka hesap adı": "Bank account name",
  "Sort code": "Sort code",
  "Hesap numarası": "Account number",
  "IBAN (opsiyonel)": "IBAN (optional)",
  "BIC (opsiyonel)": "BIC (optional)",
  "Fatura alt notu": "Invoice footer",
  "Banka sort code + hesap no (veya IBAN)": "Bank sort code + account no (or IBAN)",
  "VAT numarasının sizin tarafınızdan doğrulanması": "Your own verification of the VAT number",
  "Numaralı PDF ve e-posta taslağı hazır": "Numbered PDF and e-mail draft ready",
  "Onay kaydedildi": "Approval saved",
  "Fatura taslağı oluşturuldu": "Invoice draft created",
  "Fatura kesildi": "Invoice issued",
  "Kredi notu kesildi; yeni taslak hazır": "Credit note issued; new draft ready",
  "Son siparişler tarandı": "Recent orders scanned",
  "E-postadan okundu": "Read from e-mail",
  "Takip taslağı hazır": "Follow-up draft ready",
  "Onay hazırlanamadı": "Could not prepare the confirmation",
  "Rapor alınamadı": "Could not load the report",
  "Yüklenemedi": "Could not load",
  "Önizleme başarısız": "Preview failed",
  "İçe aktarılamadı": "Import failed",
  "Eşlenemedi": "Could not allocate",
  "Apple Music bağlandı (bu tarayıcıda).": "Apple Music connected (in this browser).",
  "Apple Music izni verilmedi.": "Apple Music permission was not granted.",
  "MusicKit yüklenemedi.": "MusicKit could not be loaded.",
  "MusicKit yüklenemedi (ağ).": "MusicKit could not be loaded (network).",
  "MusicKit yanıt vermedi.": "MusicKit did not respond.",
  "Apple Music bağlı değil — Ayarlar → Bağlantılar → Apple Music → Bağlan.": "Apple Music is not connected — Settings → Connections → Apple Music → Connect.",
  "Geçersiz müzik işlemi.": "Invalid music action.",
  "draft": "draft",
  "sent": "sent",
  "accepted": "accepted",
  "started": "started",
  "issued": "issued",
  "paid": "paid",
  "cancelled": "cancelled",
  "unpaid": "unpaid",
  "partial": "partial",
  "pending": "pending",
  "draft_prepared": "draft prepared",
  "stale": "balance changed",
  "closed": "closed",
  "due": "due",
  "overdue": "overdue",
  "current": "current",
  "savings": "savings",
  "card": "card",
  "other": "other",
  "email": "e-mail",
  "in_person": "in person",
  "phone": "phone",
  "signed_document": "signed document",
  "message": "message",
  "proposal_accepted": "proposal accepted",
  "explicit_accept": "explicit acceptance",
  "conditional": "conditional",
  "unclear": "unclear",
  "negative": "negative",
  "mentions_other_document": "mentions another document",
  "negative_or_cancel_wording": "negative/cancel wording",
  "conditional_or_question_wording": "conditional or question wording",
  "no_explicit_acceptance_phrase": "no explicit acceptance phrase",
  "sender_is_not_client_email": "sender is not the client's e-mail",
  "client_email_unknown": "client e-mail unknown",
  "not_linked_to_this_quote": "not linked to this quote",
  "empty_reply": "empty reply",
  "multiple_invoices_referenced": "several invoices referenced",
  "wrong_currency": "wrong currency",
  "partial_payment": "partial payment",
  "overpayment": "overpayment",
  "no_reference_match": "no reference match",
  "ambiguous": "ambiguous",
  "reference": "reference",
  "exact_amount": "exact amount",
  "payer_name": "payer name",
  "currency_mismatch": "currency mismatch",
  "ordered": "ordered",
  "dispatched": "dispatched",
  "delivered": "delivered",
  "delayed": "delayed",
  "relative_or_range_wording": "relative/range wording",
  "date_range": "date range",
  "year_missing": "year missing",
  "multiple_dates": "multiple dates",
  "no_delivery_date_found": "no delivery date found",
  "supplier_mentions_delay": "supplier mentions a delay",
  "new": "new",
  "duplicate": "duplicate",
  "duplicate_in_file": "duplicate in file",
  "possible_bank_duplicate": "possible bank duplicate",
  "error": "error",
  "refund_received": "refund received",
  "reversal_or_refund_paid": "reversal / refund paid out",
  "tahmini": "estimated",
  "atanmış maliyet": "attributed costs",
  "income": "income",
  "refund": "refund",
  "materials": "materials",
  "subcontractor": "subcontractor",
  "tools": "tools",
  "fuel": "fuel",
  "vehicle": "vehicle",
  "software": "software",
  "insurance": "insurance",
  "telecom": "telecom",
  "utilities": "utilities",
  "rent": "rent",
  "bank_fees": "bank fees",
  "tax": "tax",
  "food": "food",
  "office": "office",
  "card_settlement": "card settlement",
  "transfer": "transfer",
  "drawings": "drawings",
  "uncategorized": "uncategorised",
  "Yönetim raporudur; yasal/vergi muhasebesi değildir. Kaynak: JARVIS kayıtları ve içe aktarılan banka verisi.": "Management report only — not statutory or tax accounting. Source: JARVIS records and imported bank data.",
  "Banka verisi yok: nakit giriş/çıkış ve giderler EKSİK. Ekstre içe aktarın.": "No bank data: cash in/out and expenses are INCOMPLETE. Import a statement.",
  "Bazı giderler bir projeye atanmadı; proje kârlılığı 'tahmini' olarak işaretlendi.": "Some expenses are not attributed to a project; project margin is marked 'estimated'.",
  "Kredi kartı ödemesi var ama kart hesabı içe aktarılmadı: kart harcamaları kalem kalem görünmüyor; kart ödemesi tek gider olarak sayıldı.": "A credit-card payment exists but the card account was not imported: card purchases are not itemised; the card payment is counted as one expense.",
  "Banka sağlayıcısı bağlı değil: hiçbir bankaya bağlanılmadı. Ekstreleri CSV/Excel olarak içe aktarın. Gerçek bağlantı için bir açık bankacılık (AIS) sağlayıcısı seçip yalnızca okuma izinleriyle yapılandırmanız gerekir.": "No bank provider connected: no bank has been contacted. Import statements as CSV/Excel. A real connection needs an open-banking (AIS) provider configured with read-only permissions.",
  "Salt-okunur sağlayıcı bağdaştırıcısı etkin.": "Read-only provider adapter active.",
  "Apple Developer Program üyeliği + MusicKit anahtarı (Team ID, Key ID, .p8)": "Apple Developer Program membership + MusicKit key (Team ID, Key ID, .p8)",
  "Tam çalma için Apple Music aboneliği (Apple kuralı)": "An Apple Music subscription for full playback (Apple's rule)",
  "Bağlantı ve çalma tarayıcıda (MusicKit JS); kullanıcı jetonu tarayıcıda kalır": "Connection and playback happen in the browser (MusicKit JS); the user token stays in the browser",
  "quote_status_draft": "quote is still a draft",
  "quote_status_sent": "quote status: sent",
  "quote_status_accepted": "quote already accepted",
  "quote_status_partial": "quote status: partial",
  "quote_status_started": "quote already started",
};
